import Cookies from 'js-cookie';
import css from './dynamicRoutingWidget.css?raw';

const COOKIE_NAME = 'dynamic_route';

export function showDynamicRoutingWidget() {
  if (typeof window === 'undefined') {
    return;
  }

  const handleClick = () => {
    const newCookie = window.prompt(
      'Set cookie (leave empty to delete)',
      Cookies.get(COOKIE_NAME),
    );

    if (newCookie === null) {
      return;
    }

    if (newCookie !== '') {
      Cookies.set(COOKIE_NAME, newCookie);
    } else {
      Cookies.remove(COOKIE_NAME);
    }
    window.location.reload();
  };

  const dynamicRoutingEnabled = !!Cookies.get(COOKIE_NAME);

  const widget = document.createElement('div');
  widget.classList.add('dynamicRoutingWidget');

  if (dynamicRoutingEnabled) {
    widget.innerHTML = 'Dynamic routing <strong>on</strong>';
  } else {
    widget.innerHTML = 'Dynamic routing off';
  }

  widget.addEventListener('click', handleClick);

  const body = document.body;
  body.appendChild(widget);

  const style = document.createElement('style');
  style.innerHTML = css;
  body.appendChild(style);
}
